import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { BuyerAPI } from "../../Apis/buyerAPI";
import { SellerAPI } from "../../Apis/sellerAPI";
import { CommonAPI } from "../../Apis/commonApi";
import { EventInterface } from "../../Interface/CommonInterface";
import { MEETING_REQUEST_STATUS, Buyerscreens } from "../../Constants/data";
import { errorHandler } from "../../Utils/handler";
import { isNewMeetingAllowed } from "../../Utils/meetingUtils"; // Claude: shared util 10-04-2026
import { useToastWrapper } from "../../Wrapper/toastWrapper";
import actions from "../../redux/Actions";

// Claude: extracted from SellersList.tsx 23-03-2026
const useSellersListState = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const sellerAsset = useSelector((state: any) => state.sellerAsset);
  const user = useSelector((state: any) => state.user);
  const filterToggleRef = useRef<HTMLButtonElement>();
  const isInitialRender = useRef(true);
  const sentinelRef = useRef<HTMLDivElement>(null);
  const [searchParams, setSearchParams] = useSearchParams();

  const { success, error } = useToastWrapper();

  const [relevanceData, setRelevanceData] = useState({
    prequalified_company_name: "",
    prequalified_user_id: "",
    event_id: "",
    status: "Under_Research",
  });

  const [isTagsFilterActive, setIsTagsFilterActive] = useState(false);

  const [docsModal, setDocsModal] = useState(false);
  const handleOpenDocsModal = () => setDocsModal(true);
  const handleCloseDocsModal = () => setDocsModal(false);
  const [personName, setPersonName] = useState("");
  const [currentSeller, setCurrentSeller] = useState<any>({});

  const [sortModal, setSortModal] = useState(false);
  const handleOpenSortModal = () => setSortModal(true);
  const handleCloseSortModal = () => setSortModal(false);

  const [filterModal, setFilterModal] = useState(false);
  const handleOpenFilterModal = () => setFilterModal(true);
  const handleCloseFilterModal = () => setFilterModal(false);

  const [tagsFilter, setTagsFilter] = useState(false);
  const handleOpenTagsFilterModal = () => setTagsFilter(true);
  const handleCloseTagsFilterModal = () => setTagsFilter(false);

  const [interestedTags, setInterestedTags] = useState<string[]>([]);
  const [selectedTags, setSelectedTags] = useState<string[]>([]);

  const [releModal, setReleModal] = useState(false);
  const handleOpenRelevanceModal = () => setReleModal(true);
  const handleCloseRelevanceModal = () => setReleModal(false);

  const [orderSort, setOrderSort] = useState("a-to-z");
  const [relevanceSort, setRelevanceSort] = useState("");

  const [notesModal, setNotesModal] = useState(false);
  const handleOpenNotesModal = () => setNotesModal(true);
  const handleCloseNotesModal = () => setNotesModal(false);
  const [notesData, setNotesData] = useState<any>({ forUser: "", eventId: "" });

  const [meetModal, setMeetModal] = useState(false);
  const [verifyGateOpen, setVerifyGateOpen] = useState(false);
  const handleOpenMeetModal = () => {
    if (["unverified", "resubmitted"].includes(user?.verificationStatus)) { setVerifyGateOpen(true); return; }
    setMeetModal(true);
  };
  const handleCloseMeetModal = () => setMeetModal(false);
  const [meetResponder, setMeetResponder] = useState<any>();

  const [accordionActive, setAccordionActive] = useState("");
  const [sellerEvents, setSellerEvents] = useState<Record<string, any[]>>({});

  const [tagsModel, setTagsModal] = useState(false);
  const handleOpenTagsModal = () => setTagsModal(true);
  const handleCloseTagsModal = () => setTagsModal(false);
  const [tagsData, setTagsData] = useState<string[]>([]);

  const [meetConfirm, setMeetConfirm] = useState(false);
  const handleOpenMeetConfirmModal = () => setMeetConfirm(true);
  const handleCloseMeetConfirmModal = () => { setMeetConfirm(false); setCurrentMeet(""); };
  const [currentMeet, setCurrentMeet] = useState("");

  const [search, setSearch] = useState("");
  const [resetSearch, setResetSearch] = useState(false);
  const [filterCountry, setFilterCountry] = useState<string>("");
  const [filterIndustry, setFilterIndustry] = useState<string>("");
  const [countryOptions, setCountryOptions] = useState<{ value: string; label: string }[]>([]);
  const [industryOptions, setIndustryOptions] = useState<{ value: string; label: string; id: string }[]>([]);
  const [allIndustries, setAllIndustries] = useState<{ value: string; label: string; id: string }[]>([]);

  const [loading, setLoading] = useState(false);
  const [inputs, setInputs] = useState({ event: "", company: "" });
  const [event, setEvent] = useState<EventInterface[]>([]);
  const [companies, setCompanies] = useState<any>([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [hasMore, setHasMore] = useState(false);
  const [isFetchingMore, setIsFetchingMore] = useState(false);
  const [buyerData, setBuyerData] = useState<any>({});
  const [meetingData, setMeetingData] = useState<any>([]);

  const resetFilters = () => {
    if (search !== "") setResetSearch(!resetSearch);
    setSearch("");
    setOrderSort("a-to-z");
    if (orderSort === "z-to-a") filterToggleRef.current?.click();
    setRelevanceSort("");
    setSelectedTags([]);
  };

  const getEvents = async () => {
    try {
      setLoading(true);
      const [data, data2, data3] = await Promise.all([
        BuyerAPI.getAllEvents(), // Claude: Changed to getAllEvents() — shows all platform events, not just buyer-linked events 10-03-2026
        BuyerAPI.getBuyerProfile(),
        CommonAPI.GetMeeting({ status: undefined }),
      ]);
      if (data?.success) {
        const arr2 = [...data.data.data].filter((s) => moment(s.startDate).isBefore(moment()));
        setEvent([...arr2].reverse());
      }
      if (data2) setBuyerData(data2?.data?.data);
      if (data3) {
        const response = JSON.parse(JSON.stringify(data3.data.data));
        let meetingDataObj: any = {};
        response.forEach((element: any) => {
          const temp = {
            _id: element._id,
            requesterId: element.requesterId,
            responderId: element.responderId,
            requesterStatus: element.requesterStatus,
            responderStatus: element.responderStatus,
          };
          const key = user.user === element.requesterId ? element.responderCompany : element.requesterCompany;
          meetingDataObj[key] = temp;
        });
        setMeetingData(meetingDataObj);
      }
    } catch (err: any) {
      error(errorHandler(err));
    }
  };

  const getInterestedTags = async () => {
    try {
      setLoading(true);
      const params: any = { eventId: inputs?.event };
      const data = await BuyerAPI.getInterestedTags(params);
      if (data.success) setInterestedTags(data.data.data);
    } catch (err: any) {
      error(errorHandler(err));
    }
  };

  // Claude: fetch taxonomy for industry autosuggest + pre-load distinct countries 25-02-2026
  const loadFilterData = async () => {
    try {
      const [industryData, countryData] = await Promise.all([
        CommonAPI.getIndustry(),
        CommonAPI.searchSellerCountries(""),
      ]);
      if (industryData?.success) {
        const opts = (industryData.data || []).map((n: any) => ({ value: String(n._id), label: n.name, id: String(n._id) }));
        setAllIndustries(opts);
        setIndustryOptions(opts);
      }
      if (countryData?.success) {
        setCountryOptions((countryData.data || []).map((c: string) => ({ value: c, label: c })));
      }
    } catch {}
  };

  const handleCountrySearch = async (q: string) => {
    try {
      const data = await CommonAPI.searchSellerCountries(q);
      if (data?.success) setCountryOptions((data.data || []).map((c: string) => ({ value: c })));
    } catch {}
  };

  const handleIndustrySearch = (q: string) => {
    if (!q) { setIndustryOptions(allIndustries); return; }
    setIndustryOptions(allIndustries.filter((i) => i.label.toLowerCase().includes(q.toLowerCase())));
  };

  // Claude: pageNum + append support for infinite scroll 25-02-2026
  const getSellerCompanies = async (eventId: string, o: string = orderSort, pageNum: number = 1, append: boolean = false) => {
    try {
      if (append) setIsFetchingMore(true);
      else setLoading(true);
      const params: any = { page: pageNum, limit: 20 };
      if (eventId) params["eventId"] = eventId;
      if (search) params["search"] = search;
      if (o) params["filter"] = o;
      if (relevanceSort) params["categoryToFilter"] = relevanceSort;
      if (selectedTags.length > 0) params["tags"] = selectedTags;
      if (filterCountry) params["country"] = filterCountry;
      if (filterIndustry) params["industry"] = filterIndustry;
      const data = await BuyerAPI.getSellers(params);
      if (data.success) {
        const { items, total: t, hasMore: hm } = data?.data?.data;
        if (append) setCompanies((prev: any) => [...prev, ...items]);
        else setCompanies(items);
        setTotal(t);
        setHasMore(hm);
        setPage(pageNum);
      }
    } catch (err: any) {
      error(errorHandler(err));
    } finally {
      setLoading(false);
      setIsFetchingMore(false);
    }
  };


  const getAssets = async (sellerId: string) => {
    try {
      const res = await SellerAPI.getAssetsByUserId(sellerId);
      if (res) {
        dispatch(actions.sellerAssets.setAssets({ links: res.data.data }));
        handleOpenDocsModal();
      }
    } catch (err) {
      error(errorHandler(err as any));
    }
  };

  useEffect(() => {
    const oSort = searchParams.get("o");
    const rSort = searchParams.get("r");
    setOrderSort(oSort || "a-to-z");
    setRelevanceSort(rSort || "");
    isInitialRender.current = false;
    dispatch(actions.buyerMenu.set({ activeMenu: Buyerscreens.DETAILS }));
  }, []);

  useEffect(() => { setSearchParams({ o: orderSort }); }, [orderSort]);
  useEffect(() => { getEvents(); loadFilterData(); }, []);
  useEffect(() => { if (inputs.event) getInterestedTags(); }, [inputs?.event]);

  useEffect(() => {
    if (isInitialRender.current == false) getSellerCompanies(inputs?.event);
  }, [inputs?.event, orderSort, relevanceSort, selectedTags, resetSearch, filterCountry, filterIndustry]);

  // Claude: IntersectionObserver triggers next page when sentinel div enters viewport 25-02-2026
  useEffect(() => {
    if (!sentinelRef.current || !hasMore || isFetchingMore || loading) return;
    const observer = new IntersectionObserver(
      (entries) => { if (entries[0].isIntersecting) getSellerCompanies(inputs?.event, orderSort, page + 1, true); },
      { threshold: 0.1 }
    );
    observer.observe(sentinelRef.current);
    return () => observer.disconnect();
  }, [hasMore, isFetchingMore, loading, page]);

  return {
    navigate, sellerAsset, filterToggleRef, user,
    relevanceData, setRelevanceData, isTagsFilterActive,
    docsModal, handleOpenDocsModal, handleCloseDocsModal, personName, setPersonName, currentSeller,
    sortModal, handleCloseSortModal,
    filterModal, handleCloseFilterModal,
    tagsFilter, handleOpenTagsFilterModal, handleCloseTagsFilterModal,
    interestedTags, setInterestedTags, selectedTags, setSelectedTags,
    releModal, handleOpenRelevanceModal, handleCloseRelevanceModal,
    orderSort, setOrderSort, relevanceSort, setRelevanceSort,
    notesModal, handleOpenNotesModal, handleCloseNotesModal, notesData, setNotesData,
    meetModal, verifyGateOpen, setVerifyGateOpen, handleOpenMeetModal, handleCloseMeetModal, meetResponder, setMeetResponder,
    accordionActive, setAccordionActive, sellerEvents, setSellerEvents,
    tagsModel, handleOpenTagsModal, handleCloseTagsModal, tagsData, setTagsData,
    meetConfirm, handleOpenMeetConfirmModal, handleCloseMeetConfirmModal, currentMeet, setCurrentMeet,
    search, setSearch, filterCountry, setFilterCountry, filterIndustry, setFilterIndustry,
    countryOptions, industryOptions, inputs, setInputs, event,
    companies, total, hasMore, isFetchingMore, sentinelRef,
    buyerData, meetingData, loading,
    error, success,
    resetFilters, getSellerCompanies, getAssets, isNewMeetingAllowed,
  };
};

export default useSellersListState;
